import './header.css';

import * as React from 'react';
import { Storage, translate, Translate } from 'react-jhipster';
import { Navbar, Nav, NavbarToggler, NavbarBrand, Collapse } from 'reactstrap';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import LoadingBar from 'react-redux-loading-bar';

import { Home, Brand } from './header-components';
import { AccountMenu, LocaleMenu } from './menus';
import { showTimer, hideTimer } from 'app/shared/util/toast-util';

export interface IHeaderProps extends RouteComponentProps<{}> {
  isAuthenticated: boolean;
  isAdmin: boolean;
  ribbonEnv: string;
  isInProduction: boolean;
  isSwaggerEnabled: boolean;
  currentLocale: string;
  onLocaleChange: Function;
}

export interface IHeaderState {
  menuOpen: boolean;
}

class Header extends React.Component<IHeaderProps, IHeaderState> {
  state: IHeaderState = {
    menuOpen: false
  };

  handleLocaleChange = event => {
    this.props.onLocaleChange(event.target.value);
  };

  renderDevRibbon = () =>
    this.props.isInProduction === false ? (
      <div className="ribbon dev">
        <a href="">
          <Translate contentKey={`global.ribbon.${this.props.ribbonEnv}`} />
        </a>
      </div>
    ) : null;

  toggleMenu = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
  };

  componentDidMount() {
    if (Storage.session.get('ORDER_TOKEN')) {
      showTimer(Storage.session.get('ORDER_TOKEN'), this.props.history);
    } else {
      hideTimer();
    }
  }

  render() {
    const { currentLocale, isAuthenticated, isAdmin, isSwaggerEnabled, isInProduction } = this.props;

    /* jhipster-needle-add-element-to-menu - JHipster will add new menu items here */

    return (
      <div id="app-header">
        {/*{this.renderDevRibbon()}*/}
        <LoadingBar className="loading-bar" />
        {/*<Navbar light expand="sm" fixed="top" className="jh-navbar">
          <Brand />
          <Collapse isOpen={this.state.menuOpen} navbar>
            <Nav id="header-tabs" className="ml-auto" navbar>
              <Home />
              <LocaleMenu currentLocale={currentLocale} onClick={this.handleLocaleChange} />
              <AccountMenu isAuthenticated={isAuthenticated} />
              <li className="nav-item">
                <a href="https://www.facebook.com/" target="_blank">
                  <img src="static/images/fb-logo.png" />
                </a>
              </li>
            </Nav>
          </Collapse>
          <NavbarToggler aria-label="Menu" onClick={this.toggleMenu} />
        </Navbar>*/}
      </div>
    );
  }
}

export default withRouter(Header);
